// components/ViewMenuItemModal.tsx
'use client';

import type { FC } from 'react';
import { Stack, Text, Image, Badge, Divider } from '@mantine/core';
import { IconLeaf, IconClock } from '@tabler/icons-react';
import type { ModalProps } from '@mantine/core';
import type { MenuItem } from '../types';
import { Modal } from './Modal';

interface ViewMenuItemModalProps extends ModalProps {
  menuItem?: MenuItem;
}

export const ViewMenuItemModal: FC<ViewMenuItemModalProps> = ({ menuItem, ...rest }) => {
  if (!menuItem) return null;

  return (
    <Modal
      size="md"
      centered
      title={
        <Stack gap={4}>
          <Text fw={700} size="xl">
            {menuItem.name}
          </Text>
          {menuItem.isVegetarian && (
            <Badge color="green" variant="light" leftSection={<IconLeaf size={12} />}>
              Vegetarian
            </Badge>
          )}
        </Stack>
      }
      {...rest}
    >
      <Stack gap="md">
        {menuItem.image && (
          <Image
            src={menuItem.image}
            alt={menuItem.name}
            radius="md"
            style={{ maxHeight: 400, objectFit: 'cover' }}
          />
        )}

        <Divider />

        <Stack gap="xs">
          <Text size="xl" fw={700} c="orange.7">
            ₹{menuItem.price}
          </Text>

          {menuItem.description && (
            <>
              <Text fw={600} size="sm" c="dimmed">
                Description
              </Text>
              <Text>{menuItem.description}</Text>
            </>
          )}

          {menuItem.preparationTime && (
            <Stack gap={4}>
              <Text fw={600} size="sm" c="dimmed">
                Preparation Time
              </Text>
              <Text size="sm" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <IconClock size={16} />
                {menuItem.preparationTime} minutes
              </Text>
            </Stack>
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};